import React from "react";

import NavBar from "../components/NavBar";
import Banner from "../components/Banner";
import About from "../components/About";
import Pricing from "../components/Pricing";
import Testimonial from "../components/Testimonial";
import Team from "../components/Team";
import Contact from "../components/Contact";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";

import $ from "jquery";

$(function () {
  var currentHash = "/";
  $(document).scroll(function () {
    $(".hash").each(function () {
      var top = window.pageYOffset;
      var distance = top - $(this).offset().top;
      var hash = $(this).attr("id");

      if (distance < 30 && distance > -30 && currentHash != hash) {
        window.location.href = "#" + hash;
        currentHash = hash;
      }
    });
  });
});
const Home = () => {
  localStorage.removeItem("InterViewData");
  return (
    <div>
      <NavBar />
      <Banner />
      <About />
      <Pricing />
      <Testimonial />
      <Team />
      {/* <ContactForm /> */}
      {/* <Contact /> */}
      <Footer />
    </div>
  );
};

export default Home;
